import { IVisibleLogic } from 'config'
import { isVisibleFieldVisibleProps } from 'utils/loan'

export interface IOverviewStepTitleRule {
  title: string
  visibleLogic: IVisibleLogic[][]
}

export interface IOverviewStepTitleConfig {
  default?: string
  show?: boolean
  rules: IOverviewStepTitleRule[]
}

export type TOverviewStepTitlesConfig = Record<string, IOverviewStepTitleConfig>

/**
 * Step keys that admins can override the overview-page title for.
 *
 * To add support for a new step key in the future (e.g. `lockRate`, `dataComplete`),
 * just add an entry here. The Admin UI and the override resolver pick everything up
 * automatically.
 */
export const overviewStepTitleKeys: Record<string, string> = {
  signApplication: 'Sign Application',
  creditScorePull: 'Pull Credit Score',
}

/**
 * Resolves the overridden title for the given step key, evaluating any conditional
 * rules against the loan's current data via {@link isVisibleFieldVisibleProps}.
 * Returns `undefined` if no override is configured for this step (so callers can
 * fall back to their built-in default).
 */
export const resolveOverviewStepTitle = (
  config: TOverviewStepTitlesConfig | undefined | null,
  stepKey: string,
): string | undefined => {
  const cfg = config?.[stepKey]
  if (!cfg) return undefined
  if (!cfg.show && cfg.show !== undefined) return ''

  if (Array.isArray(cfg.rules)) {
    for (const rule of cfg.rules) {
      if (!rule?.title) continue
      if (isVisibleFieldVisibleProps({ visibleLogic: rule.visibleLogic })) return rule.title
    }
  }

  return cfg.default || undefined
}
